// Contenuti centrali del sito — modificabili.
export const IMAGES = {
  portrait: "/images/susanna-paoletti.webp",
  natureTexture: "https://static.prod-images.emergentagent.com/jobs/8c3971a7-93c9-47d0-b512-5cb05fce9398/images/fe234423f0bf11d08e6754536f6c00c9fef693a1400b5146ace4209d3c93ede4.jpeg",
  plant: "https://images.unsplash.com/photo-1483794344563-d27a8d18014e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  softLight: "https://images.unsplash.com/photo-1760243790660-a7958d7843ee?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  windowShadow: "https://images.unsplash.com/photo-1529047033375-f402d3da24ca?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Chi sono", to: "/chi-sono" },
  { label: "Approccio", to: "/approccio" },
  {
    label: "Percorsi",
    children: [
      { label: "Percorsi ed interventi", to: "/aree-di-intervento" },
      { label: "Aree di Intervento", to: "/aree-di-intervento#aree-intervento" },
    ],
  },
  { label: "EMDR Macerata", to: "/emdr-macerata" },
  { label: "Formazione", to: "/formazione" },
  { label: "Esperienze", to: "/esperienze" },
  { label: "FAQ", to: "/faq" },
  { label: "Contatti", to: "/contatti" },
];

export const HERO = {
  name: "Susanna Paoletti",
  role: "Psicologa · Psicoterapeuta",
  location: "Macerata, Marche",
  titleLines: ["Uno spazio di ascolto,", "comprensione e cambiamento."],
  heroSubtitle: "Psicoterapia individuale e di coppia a Macerata, con un percorso costruito sulla persona.",
  intro:
    "Percorsi di consulenza psicologica e psicoterapia rivolti alla persona, in un ambiente riservato e non giudicante.",
  presentation:
    "Accompagno le persone in percorsi costruiti sull'ascolto e sul rispetto dei tempi di ciascuno. La mia esperienza si è formata nella psicologia clinica, nella psicoterapia cognitivo-comportamentale, nell'EMDR e nella valutazione psicologica. Utilizzo gli strumenti della psicoterapia in modo flessibile e personalizzato, scegliendo, sulla base della valutazione e degli obiettivi concordati, gli interventi più adeguati alla persona e al momento che sta attraversando. Ogni persona è diversa e non esiste un unico modo di attraversare una difficoltà.",
  presentationItalic: "Non è la persona a doversi adattare a un metodo:",
  presentationHighlight: "è il percorso terapeutico che deve adattarsi alla persona.",
};

export const MARQUEE_WORDS = [
  "Ascolto",
  "Comprensione",
  "Riservatezza",
  "Fiducia",
  "Cambiamento",
  "Cura",
  "Rispetto",
];

export const AREE_INTRO =
  "I servizi qui descritti sono rivolti a individui maggiorenni e alle coppie.";

export const AREE = [
  {
    n: "01",
    title: "Consulenza e sostegno psicologico",
    desc: "Uno spazio per esplorare un momento di difficoltà, chiarire pensieri ed emozioni e individuare insieme possibili direzioni. Contatta lo studio per valutare se il percorso è adatto alle tue esigenze.",
  },
  {
    n: "02",
    title: "Psicoterapia individuale",
    desc: "Un percorso personale, costruito sulla relazione terapeutica, per affrontare disagi emotivi e situazioni di sofferenza con tempi e obiettivi condivisi.",
  },
  {
    n: "03",
    title: "Psicoterapia cognitivo-comportamentale",
    desc: "Un approccio orientato a comprendere il rapporto tra pensieri, emozioni e comportamenti, per riconoscere schemi ricorrenti e sperimentare modalità nuove.",
  },
  {
    n: "04",
    title: "Terapia EMDR",
    desc: "Un approccio psicoterapeutico utilizzato da professionisti adeguatamente formati per lavorare su esperienze traumatiche o emotivamente difficili. Ogni intervento viene valutato individualmente.",
  },
  {
    n: "05",
    title: "Assessment psicologico",
    desc: "Percorsi di valutazione per una lettura più chiara del funzionamento psicologico, come base per orientare eventuali interventi.",
  },
  {
    n: "06",
    title: "Sostegno in patologie neurologiche e sclerosi multipla",
    desc: "Sostegno psicologico rivolto a chi convive con patologie neurologiche, maturato in ambito clinico ospedaliero e associativo.",
  },
  {
    n: "07",
    title: "Terapia di coppia",
    desc: "Uno spazio sicuro dove la coppia può individuare le dinamiche relazionali e i cicli interpersonali disfunzionali per trovare un nuovo e sano equilibrio di coppia.",
  },
  {
    n: "08",
    title: "Counseling",
    desc: "Interventi mirati e circoscritti per orientarsi di fronte a scelte, cambiamenti o momenti di incertezza.",
  },
  {
    n: "09",
    title: "Salute mentale e benessere psicologico",
    desc: "La cura di sé come percorso: prevenzione, consapevolezza e attenzione al proprio equilibrio emotivo nel tempo.",
  },
];

export const FORMAZIONE = [
  {
    year: "2001",
    title: "Laurea in Psicologia con indirizzo di Psicologia Clinica e di Comunità",
    place: "Università degli Studi di Urbino — 110/110.",
  },
  {
    year: "2003",
    title: "Abilitazione alla professione di Psicologo",
    place: "Superamento dell'Esame di Stato per l'esercizio della professione di Psicologo.",
  },
  {
    year: "2004",
    title: "Iscrizione all'Ordine degli Psicologi delle Marche",
    place: "Albo professionale n. 1078 — data di iscrizione 07/02/2004.",
  },
  {
    year: "2007",
    title: "Specializzazione in Psicoterapia Cognitiva e Cognitivo-Comportamentale",
    place: "Scuola Studi Cognitivi — 30/30 e lode.",
  },
  {
    year: "2010",
    title: "Corso di Perfezionamento in Sessuologia Clinica",
    place: "Approfondimento delle tematiche legate alla sfera sessuale e relazionale.",
  },
  {
    year: "2012",
    title: "Abilitazione al trattamento con E.M.D.R. di secondo livello",
    place:
      "E.M.D.R. — Eye Movement Desensitization and Reprocessing (Desensibilizzazione e Rielaborazione attraverso i Movimenti Oculari): un approccio per l'elaborazione di esperienze traumatiche o emotivamente difficili.",
  },
  {
    year: "2015",
    title: "Accredited Practitioner in E.M.D.R.",
    place: "Titolo conseguito presso l'associazione E.M.D.R. Europea.",
  },
];

export const FORMAZIONE_NOTE =
  "Nel corso degli anni ho mantenuto una formazione professionale costante, partecipando regolarmente a corsi di aggiornamento, seminari e percorsi formativi ECM nell'ambito della psicologia e della psicoterapia.";

export const ESPERIENZE = [
  "La mia prima esperienza professionale risale ai tempi della mia Tesi Sperimentale, quando ho avuto il privilegio di osservare e descrivere la Terapia Multifamiliare rivolta a un gruppo di famiglie di persone con dipendenze patologiche.",
  "Durante i vari tirocini ho avuto l'opportunità di osservare professionisti operare in realtà differenti e con diversi approcci: dalla neuropsicologia alla psichiatria, dai disturbi alimentari fino alle terapie di gruppo.",
  "Dal 2003 al 2016 ho lavorato presso il Centro Sclerosi Multipla dell'U.O. di Neurologia dell'Ospedale di Macerata, occupandomi delle valutazioni neuropsicologiche e del sostegno psicologico rivolto ai pazienti con sclerosi multipla. Contemporaneamente svolgevo attività di terapia di gruppo per l'AISM.",
  "Negli anni ho avuto modo di partecipare ad alcune pubblicazioni e di svolgere docenze.",
  "Dal 2005 svolgo attività libero-professionale presso il mio studio, dove mi occupo di psicoterapia individuale e terapia di coppia.",
];

export const PUBBLICAZIONI = [
  {
    year: "2015",
    text: 'Articolo "Il Ruolo dello Psicologo in un Centro Sclerosi Multipla" per il periodico "SMart", Supplemento n. 3 al Vol. VII - n. 3 (Luglio/Settembre) 2015, CIC Edizioni Internazionali S.r.l.',
  },
  {
    year: "2008 – 2011",
    text: "Collaborazione con il Dott. A. Canevaro (Medico Psicoterapeuta, membro della American Family Therapy Academy) e il Dott. S. Bonifazi nella stesura di un capitolo del testo per specialisti \"Il gruppo multifamiliare — un approccio esperienziale\", pubblicato nel Maggio 2011.",
  },
  {
    year: "2005",
    text: 'Articolo "Psicologia e Sclerosi Multipla" nel numero di Settembre 2005 (Anno XI, N. 2) della rivista Psico-In, rivista di divulgazione scientifica dell\'Ordine degli Psicologi delle Marche.',
  },
  {
    year: "2004",
    text: 'Poster "Le innovazioni tecnologico-sanitarie migliorano le credenze depressive e la qualità di vita del paziente anziano" (Carassai M., Forti M., Marzullo R.L., Paoletti S.), presentato al XII Congresso Nazionale SITCC 2004 (Società Italiana di Terapia Comportamentale e Cognitiva), Verona, Ottobre 2004.',
  },
];

export const DOCENZE = [
  {
    year: "2011",
    text: "Relatrice al Corso di Formazione per Assistenti Familiari per persone affette da malattia di Alzheimer, organizzato dall'Associazione AFAM presso l'Ospedale di Macerata, Marzo 2011.",
  },
  {
    year: "2010",
    text: 'Relatrice a un Corso di Formazione dal titolo "Conoscere l\'Alzheimer", rivolto ai familiari di persone affette da demenza di Alzheimer e agli operatori dei servizi dedicati, organizzato dall\'Associazione ANTEAS presso il Centro Polivalente per Anziani Villa Cozza (IRCR) di Macerata, Marzo-Aprile 2010.',
  },
  {
    year: "2009",
    text: 'Relatrice in un incontro di informazione e formazione rivolto ai familiari delle persone con Alzheimer per il Progetto "Servizio Alzheimer", organizzato dall\'Associazione ANTEAS, venerdì 13 Novembre 2009, presso il Centro Polivalente per Anziani Villa Cozza (IRCR) di Macerata.',
  },
  {
    year: "2009",
    text: 'Relatrice in un incontro di informazione alle donne intitolato "Meno Pausa – Più Salute", tenutosi venerdì 5 Giugno 2009 presso la Farmacia Paccacerqua di Sforzacosta (MC).',
  },
  {
    year: "2007",
    text: 'Organizzazione scientifica e docenza al "Corso di Formazione per i familiari di persone affette dalla malattia di Alzheimer o da altre demenze", tenutosi sabato 1 Dicembre 2007 presso la sede della Comunità Montana Esino-Frasassi, Fabriano (AN).',
  },
  {
    year: "2007",
    text: "Collaborazione con la Dott.ssa Antonella Pazzaglia a due incontri informativi sui Disturbi del Comportamento Alimentare rivolti agli studenti dell'Istituto d'Arte di Macerata.",
  },
];

export const CHI_SONO = [
  "Sono Susanna Paoletti, psicologa e psicoterapeuta. Lavoro con le persone partendo dall'ascolto: credo che ogni percorso debba nascere da uno spazio riservato e non giudicante, in cui sentirsi accolti prima ancora di essere compresi.",
  "Mi sono laureata in Psicologia, indirizzo di Psicologia clinica e di comunità, presso l'Università degli Studi di Urbino Carlo Bo, conseguendo la laurea nel 2001 con votazione 110/110.",
  "Nel 2007 ho ottenuto la specializzazione in Psicoterapia Cognitiva e Cognitivo-Comportamentale presso la scuola Studi Cognitivi, con votazione 30/30 e lode. Dal 2005 svolgo attività libero-professionale come psicologa e psicoterapeuta.",
  "Dal 2003 al 2016 ho collaborato con il Centro Sclerosi Multipla — Unità Operativa di Neurologia dell'Ospedale di Macerata, occupandomi delle valutazioni neuropsicologiche e del sostegno psicologico rivolto ai pazienti con sclerosi multipla; contemporaneamente svolgevo attività di terapia di gruppo per l'AISM.",
  "Nel 2010 ho conseguito un Corso di Perfezionamento in Sessuologia Clinica. Nel 2012 ho ottenuto l'abilitazione all'utilizzo della terapia EMDR di secondo livello e, nel 2015, il titolo di Accredited Practitioner in EMDR presso l'associazione EMDR Europea.",
];

export const CONTACT_PLACEHOLDERS = [
  { label: "Indirizzo", value: "Via Emanuele Filiberto 1, 62100 Macerata (MC)", href: "https://www.google.com/maps?q=Via+Emanuele+Filiberto+1,+62100+Macerata+MC" },
  { label: "Telefono", value: "+39 348 692 1696", href: "tel:+393486921696" },
  { label: "Email", value: "susannapaoletti11@gmail.com", href: "mailto:susannapaoletti11@gmail.com" },
  { label: "Disponibilità", value: "Ricevo su appuntamento" },
  { label: "Sede", value: "Macerata, Marche" },
];


export const FAQ = [
  {
    q: "Come posso capire se è il momento di iniziare un percorso psicoterapeutico?",
    a: [
      "Non è necessario trovarsi in una situazione di particolare gravità per rivolgersi a una psicologa o psicoterapeuta a Macerata. Un percorso psicologico può essere utile quando una difficoltà, una sofferenza emotiva o una situazione personale iniziano a condizionare il proprio benessere, le relazioni o la vita quotidiana.",
      "Ansia, stress, difficoltà relazionali, momenti di cambiamento, vissuti di tristezza o altre forme di disagio possono rappresentare un motivo per chiedere un supporto psicologico.",
      "Il primo colloquio con la psicologa psicoterapeuta è innanzitutto uno spazio di ascolto e conoscenza, utile per comprendere insieme la situazione e valutare se e come intraprendere un percorso di psicoterapia.",
    ],
  },
  {
    q: "Come si svolge il primo colloquio con la psicologa o psicoterapeuta?",
    a: [
      "Il primo colloquio è uno spazio dedicato alla conoscenza reciproca e alla comprensione delle ragioni che hanno portato a chiedere aiuto.",
      "Attraverso il dialogo vengono raccolte le informazioni necessarie per comprendere la situazione, le difficoltà presenti e le esigenze della persona.",
      "Non è necessario arrivare al primo incontro con una diagnosi o avere già chiaro quale sia il problema. Insieme è possibile valutare il percorso più adeguato e, quando possibile, definire i primi obiettivi di lavoro.",
    ],
  },
  {
    q: "Quanto dura un percorso di psicoterapia?",
    a: [
      "Non esiste una durata uguale per tutti. La durata di un percorso di psicoterapia a Macerata dipende dalla situazione della persona, dagli obiettivi concordati, dalle difficoltà presenti e dall'andamento del lavoro terapeutico.",
      "Il percorso viene monitorato nel tempo, valutando insieme i cambiamenti raggiunti e le eventuali necessità di ridefinire gli obiettivi.",
      "L'intervento viene quindi personalizzato in base alle esigenze della persona e all'evoluzione del percorso.",
    ],
  },
  {
    q: "Con quale frequenza si svolgono gli incontri di psicoterapia?",
    a: [
      "La frequenza degli incontri viene concordata in base alle esigenze della persona e agli obiettivi del percorso.",
      "In genere gli incontri si svolgono con cadenza regolare, soprattutto nelle fasi iniziali, per garantire continuità al lavoro terapeutico. La frequenza può essere successivamente modificata in relazione all'andamento della psicoterapia.",
    ],
  },
  {
    q: "L'EMDR viene utilizzato sempre durante la psicoterapia?",
    a: [
      "No. L'EMDR non viene utilizzato automaticamente in ogni percorso psicoterapeutico.",
      "La sua applicazione viene valutata sulla base della situazione individuale, delle esigenze della persona e degli obiettivi terapeutici. Quando indicato, l'EMDR può essere integrato con l'approccio cognitivo-comportamentale all'interno di un percorso personalizzato.",
      "La scelta degli strumenti terapeutici viene quindi effettuata caso per caso, in funzione delle caratteristiche e delle necessità della persona.",
    ],
  },
  {
    q: "Qual è la differenza tra psicologo, psicoterapeuta e psichiatra?",
    a: [
      "Lo psicologo è un professionista della salute che si occupa di valutazione psicologica, prevenzione, sostegno psicologico e interventi rivolti al benessere della persona.",
      "Lo psicoterapeuta è uno psicologo o un medico che, dopo una specifica formazione post-laurea, è abilitato a svolgere psicoterapia attraverso percorsi strutturati per affrontare condizioni di sofferenza psicologica e difficoltà personali e relazionali.",
      "Lo psichiatra è un medico specializzato in psichiatria e può effettuare diagnosi mediche e prescrivere farmaci.",
      "In alcune situazioni, psicoterapia e trattamento farmacologico possono essere integrati, quando indicato e attraverso la collaborazione tra i professionisti coinvolti.",
    ],
  },
  {
    q: "Posso iniziare un percorso di psicoterapia anche se non so esattamente cosa mi sta succedendo?",
    a: [
      "Sì. Non è necessario arrivare al primo colloquio con una diagnosi o avere già chiaro quale sia il problema.",
      "A volte si avverte semplicemente di non stare bene, di sentirsi in difficoltà o di non riuscire più ad affrontare una situazione come prima.",
      "Il percorso con una psicologa o psicoterapeuta a Macerata può aiutare a comprendere meglio ciò che sta accadendo e a individuare, insieme, le modalità più adeguate per affrontare le difficoltà presenti.",
    ],
  },
  {
    q: "Quello che racconto durante la psicoterapia è riservato?",
    a: [
      "Sì. La relazione psicoterapeutica si fonda sulla riservatezza e sul rispetto della privacy, nel rispetto della normativa vigente e degli obblighi professionali e deontologici.",
      "Le informazioni condivise durante gli incontri vengono trattate con la necessaria riservatezza e nel rispetto delle disposizioni che regolano l'attività professionale dello psicologo e dello psicoterapeuta.",
    ],
  },
  {
    q: "È possibile fare psicoterapia online?",
    a: [
      "Sì. Quando le condizioni lo consentono, è possibile svolgere gli incontri anche online, attraverso una modalità che garantisca adeguata riservatezza e continuità al percorso.",
      "La psicoterapia online può rappresentare un'alternativa agli incontri in presenza per chi, per motivi personali, lavorativi o logistici, ha difficoltà a raggiungere lo studio della psicoterapeuta a Macerata.",
      "La possibilità di svolgere il percorso online viene valutata in relazione alla situazione e alle esigenze individuali.",
    ],
  },
  {
    q: "Quanto dura un colloquio psicologico o psicoterapeutico?",
    a: [
      "La durata di un colloquio individuale o di coppia è di 50-60 minuti.",
      "Il tempo dell'incontro consente di dedicare uno spazio adeguato all'ascolto, al confronto e al lavoro terapeutico, mantenendo continuità e regolarità nel percorso.",
    ],
  },
  {
    q: "Dove riceve la psicologa e psicoterapeuta a Macerata?",
    a: [
      "Lo studio della psicologa e psicoterapeuta a Macerata si trova in Via Emanuele Filiberto 1, 62100 Macerata (MC), Marche.",
      "Lo studio offre uno spazio dedicato all'ascolto, alla valutazione psicologica e ai percorsi di psicoterapia personalizzati.",
      "È possibile contattare la psicologa psicoterapeuta per ricevere maggiori informazioni e valutare la possibilità di fissare un primo colloquio.",
    ],
  },
];


export const AREE_INTERVENTO = [
  {
    n: "01",
    title: "Ansia, paure e attacchi di panico",
    intro:
      "L'ansia può manifestarsi attraverso preoccupazioni persistenti, paura acuta, angoscia, tensione, rimuginio mentale, difficoltà a rilassarsi o sintomi fisici che possono arrivare a condizionare la vita quotidiana.",
    items: [
      "Disturbi d'ansia",
      "Disturbo d'ansia generalizzato",
      "Attacchi di panico e disturbo di panico",
      "Fobia sociale e ansia sociale",
      "Fobie specifiche",
      "Agorafobia",
    ],
  },
  {
    n: "02",
    title: "Stress e difficoltà nella gestione emotiva",
    intro:
      "Periodi di particolare pressione, cambiamenti importanti o situazioni prolungate di sovraccarico possono rendere difficile gestire emozioni, pensieri e reazioni. Il percorso può aiutare a comprendere ciò che sta accadendo, riconoscere i propri bisogni e sviluppare modalità più efficaci di gestione dello stress e delle emozioni.",
    items: [
      "Stress e sovraccarico emotivo",
      "Difficoltà nella gestione delle emozioni",
      "Difficoltà di adattamento a cambiamenti o situazioni di vita",
      "Senso di inadeguatezza e insicurezza",
      "Bassa autostima",
    ],
  },
  {
    n: "03",
    title: "Depressione e disturbi dell'umore",
    intro:
      "Quando tristezza, perdita di interesse, demotivazione, senso di colpa o difficoltà nella quotidianità diventano persistenti, un percorso psicoterapeutico può aiutare a comprendere e affrontare la sofferenza.",
    items: [
      "Depressione e disturbi depressivi",
      "Disturbi dell'umore",
      "Disturbo bipolare dell'umore, nell'ambito di un percorso integrato quando indicato",
    ],
  },
  {
    n: "04",
    title: "Disturbo ossessivo-compulsivo",
    intro:
      "Pensieri intrusivi, ossessioni e comportamenti compulsivi possono occupare una parte significativa della vita quotidiana e generare un forte disagio. Il percorso psicoterapeutico è orientato alla comprensione dei meccanismi che alimentano il disturbo e allo sviluppo di modalità più funzionali per gestire pensieri, emozioni e comportamenti.",
    items: [
      "Disturbo ossessivo-compulsivo (DOC)",
      "Ossessioni e compulsioni",
      "Pensieri intrusivi",
      "Comportamenti ripetitivi legati all'ansia",
    ],
  },
  {
    n: "05",
    title: "Disturbi della nutrizione e dell'alimentazione",
    intro:
      "Il rapporto con il cibo e con il proprio corpo può diventare fonte di sofferenza e assumere forme diverse. Mi occupo di percorsi psicoterapeutici rivolti a persone che presentano:",
    items: [
      "Anoressia nervosa",
      "Bulimia nervosa",
      "Disturbo da alimentazione incontrollata (Binge Eating Disorder)",
      "Alimentazione emotiva",
      "Difficoltà nel rapporto con il cibo e con il proprio corpo",
    ],
    note:
      "Quando necessario, il percorso psicoterapeutico può inserirsi all'interno di una presa in carico multidisciplinare, in collaborazione con le altre figure professionali coinvolte.",
  },
  {
    n: "06",
    title: "Traumi ed esperienze dolorose",
    intro:
      "Alcune esperienze possono lasciare una traccia emotiva che continua a influenzare il presente, anche molto tempo dopo che l'evento si è verificato. Il percorso può essere rivolto all'elaborazione di:",
    items: [
      "Esperienze traumatiche",
      "Eventi particolarmente dolorosi o destabilizzanti",
      "Esperienze relazionali traumatiche",
      "Disturbo post-traumatico da stress (PTSD)",
    ],
    note:
      "Quando indicato, all'interno del percorso posso integrare il lavoro psicoterapeutico con l'EMDR, secondo una valutazione individualizzata.",
  },
  {
    n: "07",
    title: "Difficoltà di coppia e relazionali",
    intro:
      "Le relazioni possono attraversare momenti di difficoltà, incomprensione o cambiamento. A volte le modalità comunicative si irrigidiscono, aumentano i conflitti o diventa difficile ritrovare vicinanza e sintonia. Il percorso può essere orientato a comprendere le dinamiche che si sono create nella relazione, favorire una comunicazione più efficace e aiutare la coppia ad affrontare le proprie difficoltà in modo più consapevole.",
    items: [
      "Crisi di coppia",
      "Conflitti e difficoltà comunicative",
      "Distanza emotiva e difficoltà nella relazione",
      "Problemi di fiducia e gelosia",
      "Difficoltà legate a cambiamenti importanti nella vita della coppia",
      "Difficoltà nella gestione dei conflitti",
      "Separazione e difficoltà legate alla fine della relazione",
    ],
  },
];
